import { useEffect, useState } from 'react';
import { Button, Form, FormGroup, Label, Input, Container } from 'reactstrap';
import Header from '../components/Header';
import { INSTITUTIONS } from '../utils/institutions';
import { createAppointment, getDepartments } from '../config/apiConfig';
import { PAYMENT } from '../utils/urls';
import moment from 'moment';

// Validation helpers

const validPastDate = (date, setValidDate) => {
  let pastDate = true;
  date = moment(date);
  pastDate = date.isBefore(moment()) && date.isAfter(moment().year(1910));
  setValidDate(pastDate);
  return pastDate;
};

const CreateAppointment = (props) => {
  const [name, setName] = useState();
  const [surname, setSurname] = useState();
  const [email, setEmail] = useState();
  const [idType, setIdType] = useState(1);
  const [idNumber, setIdNumber] = useState();
  const [birthdate, setBirthdate] = useState();
  const [gender, setGender] = useState();
  const [healthCoverage, setHealthCoverage] = useState(false);
  const [institution, setInstitution] = useState();
  const [phone, setPhone] = useState();
  const [address, setAddress] = useState();
  const [symptoms, setSymptoms] = useState(false);
  const [symptomsDate, setSymptomsDate] = useState();
  const [covid, setCovid] = useState(false);
  const [location, setLocation] = useState();

  const [department, setDepartment] = useState();
  const [anotherAppointment, setAnotherAppointment] = useState(false);
  const [wantsAnother, setWantsAnother] = useState(false);
  const [appointmentsToPay, setAppointmentsToPay] = useState([]);
  const [date, setDate] = useState();
  const [slot, setSlot] = useState();

  const [departments, setDepartments] = useState([]);
  const [validBirthdate, setValidBirthdate] = useState(true);
  const [validSymptomsDate, setValidSymptomsDate] = useState(true);

  useEffect(() => {
    if (props.location.state) {
      setDate(props.location.state.slot.date);
      setSlot(props.location.state.slot.pk);
    }
    getDepartments().then((res) => {
      setDepartments(res.data);
    });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    //validate birthdate
    const validBirthdate = validPastDate(birthdate, setValidBirthdate);
    if (!validBirthdate) return;

    //validate symptoms date
    const validSymptomsDate = validPastDate(symptomsDate, setValidSymptomsDate);
    if (symptoms && !validSymptomsDate) return;

    const selectedDepartment = departments.find((dp) => dp.pk == department);
    const completeAddress = `${address}. ${location}, ${selectedDepartment.name}`;

    createAppointment({
      name,
      surname,
      email,
      idType,
      idNumber,
      birthdate,
      gender,
      healthCoverage,
      institution,
      phone,
      address: completeAddress,
      symptoms,
      covid,
      date,
      slot,
      department,
    }).then((res) => {
      if (res.status === 201) {
        let aux = appointmentsToPay;
        aux.push(res.data.id);
        setAppointmentsToPay(aux);

        // if the user doesn't want to create another appointment: it must pay
        if (wantsAnother) {
          //reset the form inputs
          e.target.reset();
          resetAppointmentValues();
          setAnotherAppointment(true);
        } else {
          goToPayment(appointmentsToPay);
        }
      } else {
        alert('Ha ocurrido un error'); //Todo
      }
    });

    const goToPayment = (appointmentIds) => {
      props.history.push(PAYMENT, {
        appointmentIds, //pass the created appointments ids to the payment page so it can charge them
        appointmentDate: props.location.state.slot.date,
        appointmentTime: props.location.state.slot.name,
        slotAmount: props.location.state.slot.amount,
        appointmentDepartment: selectedDepartment,
        email,
      });
    };

    const resetAppointmentValues = () => {
      // we don't reset address and location state items cause the appointments created at the same time must be for different people but LIVING IN THE SAME HOUSE
      // we neither reset the slot values. Cause the extra appointments are scheduled for the same moment
      setName(null);
      setSurname(null);
      setEmail(null);
      setBirthdate(null);
      setGender(null);
      setIdType(13);
      setIdNumber(null);
      setPhone(null);
      setSymptoms(false);
      setSymptomsDate(null);
      setCovid(false);
      setWantsAnother(false);
    };
  };

  //TODO: fix this check
  if (!props.location.state) {
    props.history.push('/');
  }

  return (
    <div id="create-appointment" className="mb-5">
      <Header history={props.history} />
      <h5 className="text-center mb-4 text-secondary">
        {`Solicitud de agenda para ${moment(date, 'L').format(
          'dddd D MMMM YYYY'
        )}`}
      </h5>
      {appointmentsToPay.length > 0 && (
        <h5 className="text-center text-info mb-3">
          Datos de la persona {appointmentsToPay.length + 1}
        </h5>
      )}
      <Container className="d-flex flex-rows justify-content-center">
        <Form id="appointment-form" onSubmit={(e) => handleSubmit(e)}>
          <FormGroup>
            <Input
              placeHolder="Nombre"
              type="text"
              name="name"
              onChange={(e) => setName(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <Input
              placeHolder="Apellido"
              type="text"
              name="surname"
              onChange={(e) => setSurname(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label>Tipo de documento</Label>
            <Input
              type="select"
              name="select"
              id="exampleSelect"
              onChange={(e) => setIdType(e.target.value)}
            >
              <option value={13}>Cédula de identidad</option>
              <option value={22}>Pasaporte</option>
              <option value={17}>Otro documento extranjero</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Input
              placeHolder="Número de documento"
              type={idType === 13 ? 'number' : 'text'}
              name="name"
              id="name"
              onChange={(e) => setIdNumber(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label>Fecha de nacimiento</Label>
            <Input
              type="date"
              name="date_of_birthday"
              id="date_of_birthday"
              onChange={(e) => setBirthdate(e.target.value)}
              invalid={!validBirthdate}
              required
            />
          </FormGroup>

          <Container>
            <FormGroup tag="fieldset" row>
              <legend className="col-form-label">Sexo</legend>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="gender"
                    checked={gender === 1}
                    onChange={(e) => setGender(1)}
                    required
                  />
                  Femenino
                </Label>
              </FormGroup>
              <FormGroup check className="ml-3">
                <Label check>
                  <Input
                    type="radio"
                    name="gender"
                    checked={gender === 2}
                    onChange={(e) => setGender(2)}
                    required
                  />
                  Masculino
                </Label>
              </FormGroup>
            </FormGroup>
          </Container>

          <Container>
            <FormGroup tag="fieldset" row>
              <legend className="col-form-label">
                Cobertura de salud en Uruguay
              </legend>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="healthcare"
                    checked={healthCoverage}
                    onChange={(e) => setHealthCoverage(true)}
                  />
                  Sí
                </Label>
              </FormGroup>
              <FormGroup check className="ml-3">
                <Label check>
                  <Input
                    type="radio"
                    name="healthcare"
                    checked={!healthCoverage}
                    onChange={(e) => setHealthCoverage(false)}
                  />
                  No
                </Label>
              </FormGroup>
            </FormGroup>
          </Container>
          {healthCoverage && (
            <FormGroup>
              <Label>Institución médica</Label>
              <Input
                type="select"
                name="select"
                id="exampleSelect"
                onChange={(e) => setInstitution(e.target.value)}
              >
                {INSTITUTIONS.map((institution) => (
                  <option value={institution.pk}>{institution.name}</option>
                ))}
              </Input>
            </FormGroup>
          )}
          <FormGroup>
            <Input
              placeHolder="Email"
              type="email"
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
              name="email"
              id="email"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <Input
              placeHolder="Teléfono de contacto"
              type="number"
              name="phone"
              id="phone"
              onChange={(e) => setPhone(e.target.value)}
              required
            />
          </FormGroup>

          {!anotherAppointment && (
            <cnt>
              <FormGroup>
                <Input
                  placeHolder="Dirección"
                  type="text"
                  name="address"
                  id="address"
                  onChange={(e) => setAddress(e.target.value)}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label>Departamento</Label>
                <Input
                  type="select"
                  name="select"
                  id="department"
                  onChange={(e) => setDepartment(e.target.value)}
                  required
                >
                  <option value="" disabled selected>
                    Seleccione departamento
                  </option>
                  {departments.map((department) => (
                    <option value={department.pk}>{department.name}</option>
                  ))}
                </Input>
              </FormGroup>
              <FormGroup>
                <Input
                  placeHolder="Localidad o barrio"
                  type="text"
                  name="address"
                  id="address"
                  onChange={(e) => setLocation(e.target.value)}
                  required
                />
              </FormGroup>
            </cnt>
          )}

          <Container>
            <FormGroup tag="fieldset" row>
              <legend className="col-form-label">¿Tiene síntomas?</legend>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="symptoms"
                    checked={symptoms}
                    onChange={(e) => {
                      setSymptoms(true);
                      setValidSymptomsDate(true);
                    }}
                  />
                  Sí
                </Label>
              </FormGroup>
              <FormGroup check className="ml-3">
                <Label check>
                  <Input
                    type="radio"
                    name="symptoms"
                    checked={!symptoms}
                    onChange={(e) => {
                      setSymptoms(false);
                      setValidSymptomsDate(true);
                    }}
                  />
                  No
                </Label>
              </FormGroup>
            </FormGroup>
          </Container>

          {symptoms && (
            <FormGroup>
              <Label>Fecha de inicio de síntomas</Label>
              <Input
                type="date"
                name="symptoms_date"
                id="symptoms_date"
                invalid={!validSymptomsDate}
                onChange={(e) => setSymptomsDate(e.target.value)}
              />
            </FormGroup>
          )}

          <Container>
            <FormGroup tag="fieldset" row>
              <legend className="col-form-label">
                ¿Ha estado en contacto con un caso covid-19 positivo?
              </legend>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="covid"
                    checked={covid}
                    onChange={(e) => setCovid(true)}
                  />
                  Sí
                </Label>
              </FormGroup>
              <FormGroup check className="ml-3">
                <Label check>
                  <Input
                    type="radio"
                    name="covid"
                    checked={!covid}
                    onChange={(e) => setCovid(false)}
                  />
                  No
                </Label>
              </FormGroup>
            </FormGroup>
          </Container>

          <Container>
            <FormGroup tag="fieldset" row>
              <legend className="col-form-label">
                ¿Desea agendar otra persona para la misma dirección?
              </legend>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="anotherAppointment"
                    checked={wantsAnother}
                    onChange={(e) => setWantsAnother(true)}
                  />
                  Sí
                </Label>
              </FormGroup>
              <FormGroup check className="ml-3">
                <Label check>
                  <Input
                    type="radio"
                    name="anotherAppointment"
                    checked={!wantsAnother}
                    onChange={(e) => setWantsAnother(false)}
                  />
                  No
                </Label>
              </FormGroup>
            </FormGroup>
          </Container>

          <Button>CONTINUAR</Button>
        </Form>
      </Container>
    </div>
  );
};

export default CreateAppointment;
